<template>
  <pt-anniversary-active-sign class="pt-anniversary-active-sign__page"></pt-anniversary-active-sign>
</template>

<script>
import PtAnniversaryActiveSign from 'cps/appointment-application/pt-anniversary-active-sign/withData'
export default {
  name: 'pt-anniversary-active-sign__view',
  components: {
    'pt-anniversary-active-sign': PtAnniversaryActiveSign
  }
}
</script>
